// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 409) return "static/chunks/409.75fe3c3904864338.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"456":"0410b98a2bd81339","587":"48417425e948b33c","627":"8415499ef21d7563","765":"2e84be1a3b380f7b"}[chunkId] + ".js";
};